// @ts-nocheck
(function () {
  function asMoney(diffCents) {
    const n = Number(diffCents || 0) / 100;
    if (!Number.isFinite(n) || n === 0) return '';
    const sign = n > 0 ? '+' : (n < 0 ? '-' : '');
    const formatted = Math.abs(n).toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${sign}£${formatted}`;
  }

  function updateUrlVariant(variantId) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({ variantId }, '', url.toString());
    } catch (_e) {
      // ignore
    }
  }

  function getSelectedVariantIdFromUrl() {
    try {
      const url = new URL(window.location.href);
      const raw = url.searchParams.get('variant');
      const n = parseInt(raw || '', 10);
      return Number.isFinite(n) ? n : null;
    } catch (_e) {
      return null;
    }
  }

  function normalize(v) {
    return String(v || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function setTextAll(selector, value) {
    document.querySelectorAll(selector).forEach((el) => {
      el.textContent = value;
    });
  }

  function setSelectedByVariantId(variantId) {
    document.querySelectorAll('[data-sonno-mattress-variant] [data-variant-id]').forEach((li) => {
      const id = parseInt(li.getAttribute('data-variant-id') || '', 10);
      if (id === variantId) li.classList.add('selected');
      else li.classList.remove('selected');
    });
  }

  function updateDimsFromSelected(variantId) {
    const selected = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${variantId}"]`);
    if (!selected) return;

    const width = normalize(selected.getAttribute('data-width'));
    const length = normalize(selected.getAttribute('data-length'));

    setTextAll('[data-sonno-mattress-width]', width);
    setTextAll('[data-sonno-mattress-length]', length);
  }

  function updatePriceDiffs(selectedVariantId) {
    const selected = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${selectedVariantId}"]`);
    if (!selected) return;

    const selectedPrice = parseInt(selected.getAttribute('data-price-cents') || '0', 10) || 0;

    document.querySelectorAll('[data-sonno-mattress-variant] [data-variant-id]').forEach((li) => {
      const price = parseInt(li.getAttribute('data-price-cents') || '0', 10) || 0;
      const diff = price - selectedPrice;
      const el = li.querySelector('[data-sonno-mattress-size-price-diff]');
      if (!el) return;
      const text = asMoney(diff);
      el.textContent = text;
      el.style.display = text ? 'block' : 'none';
    });
  }

  function updateStateFromSelection(variantId) {
    const selected = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${variantId}"]`);
    if (!selected) return;

    const sizeName = selected.querySelector('.option-name')?.textContent?.trim() || '';
    const price = parseInt(selected.getAttribute('data-price-cents') || '0', 10) || 0;
    const compareAtPrice = parseInt(selected.getAttribute('data-compare-at-price-cents') || '0', 10) || 0;

    window.pdpState = window.pdpState || {};
    window.pdpState.size = sizeName;
    window.pdpState._lastVariant = {
      id: variantId,
      price,
      compare_at_price: compareAtPrice,
      option1: sizeName
    };

    try {
      window.dispatchEvent(new CustomEvent('sonno:pdpStateChanged', { detail: { ...(window.pdpState || {}) } }));
    } catch (_e) {
      // ignore
    }

    if (window.pdpPricing && typeof window.pdpPricing.updatePrice === 'function') {
      try {
        window.pdpPricing.updatePrice();
      } catch (_e) {
        // ignore
      }
    }
  }

  function bindClickHandlers() {
    const items = document.querySelectorAll('[data-sonno-mattress-variant] [data-variant-id]');
    items.forEach((li) => {
      if (li.getAttribute('data-sonno-bound') === '1') return;
      li.setAttribute('data-sonno-bound', '1');

      li.addEventListener('click', () => {
        const disabled = li.getAttribute('aria-disabled') === 'true';
        if (disabled) return;

        const variantId = parseInt(li.getAttribute('data-variant-id') || '', 10);
        if (!Number.isFinite(variantId)) return;

        const sizeName = li.querySelector('.option-name')?.textContent?.trim() || '';
        setSelectedByVariantId(variantId);
        setTextAll('[data-sonno-mattress-size-label]', sizeName);
        updateDimsFromSelected(variantId);
        updatePriceDiffs(variantId);
        updateUrlVariant(variantId);
        updateStateFromSelection(variantId);
      });
    });
  }

  function init() {
    const containers = document.querySelectorAll('[data-sonno-mattress-variant]');
    if (!containers.length) return;

    bindClickHandlers();

    const fromUrl = getSelectedVariantIdFromUrl();
    const initialFromDom = parseInt(containers[0].getAttribute('data-initial-variant-id') || '', 10);
    const initial = fromUrl || (Number.isFinite(initialFromDom) ? initialFromDom : null);

    if (initial) {
      const selected = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${initial}"]`);
      if (selected) {
        const sizeName = selected.querySelector('.option-name')?.textContent?.trim() || '';
        setSelectedByVariantId(initial);
        setTextAll('[data-sonno-mattress-size-label]', sizeName);
        updateDimsFromSelected(initial);
        updatePriceDiffs(initial);
        updateStateFromSelection(initial);
        // Keep URL consistent even if Shopify didn’t set it yet
        updateUrlVariant(initial);
      }
    } else {
      // Fall back to first selectable option
      const first = document.querySelector('[data-sonno-mattress-variant] [data-variant-id]');
      if (first) first.click();
    }
  }

  // Exposed so the colour-sibling switcher can re-bind freshly rebuilt option
  // pills after swapping products in place.
  window.sonnoVariantPills = { bind: bindClickHandlers, init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
